import { Navigate } from 'react-router-dom';

export const AppNavigation = ({
  token,
}: {
  token: string | undefined;
}) => {
  if (token) {
    return <Navigate to="/" replace />;
  } else {
    // const isOkta = JSON.parse(
    //   localStorage.getItem('isOktaUser') as string
    // );
    // if (isOkta)
    return <Navigate to="/admin-sign-in" replace />;
    // else return <Navigate to="/sign-in" replace />;
  }
};
